var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_18255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1003 4.07617H4.90029C4.01664 4.07617 3.30029 4.7681 3.30029 5.62163V16.4398C3.30029 17.2933 4.01664 17.9853 4.90029 17.9853H16.1003C16.984 17.9853 17.7003 17.2933 17.7003 16.4398V5.62163C17.7003 4.7681 16.984 4.07617 16.1003 4.07617Z",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30029 8.71484H17.7003",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6998 2.5293V5.62021",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30005 2.5293V5.62021",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_18255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.5 1.75391)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender_icon.78ad1efb41e7fc9e7a6c4f2e33b570fb.svg";
export { ForwardRef as ReactComponent };